export interface INameDisplayable {
  getDisplayName(): string;
}

export function instanceOfINameDisplayable(instance: any): instance is INameDisplayable {
  return instance
    && (instance.getDisplayName !== undefined);
}
